export default {
  setTable(state, table) {
    state.table = table;
  }
};
